import { inTools } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { ApplyCommentCountMechanics } from './ApplyCommentCountMechanics';
import { AutoOpenCommentWidgetMechanics } from './AutoOpenCommentWidgetMechanics';
import { inCommentCommands } from './CommentCommands';
import { CommentExportAdapter } from './CommentExports';
import { inMentionCommands } from './MentionCommands';
import { TagExports } from './TagExports';
import { inTaggingCommands } from './TaggingCommands';
import { TaggingMechanics } from './TaggingMechanics';
import { tagTool } from './TagTool';

export class AnnotationPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ApplyCommentCountMechanics, 'singleton', 'startable')
        .register(AutoOpenCommentWidgetMechanics, 'singleton', 'startable')
        .register(TaggingMechanics, 'singleton', 'startable')
        .plug(inCommentCommands())
        .plug(inMentionCommands())
        .plug(inExportAdapter(CommentExportAdapter))
        .plug(inExportAdapter(TagExports))
        .plug(inTaggingCommands())
        .plug(inTools(tagTool))
        ;
}
